import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { getLang } from 'utils/getLangPath';

import { UIContext } from 'context/ui';

import { Link } from 'components/link/Link';
import { MenuButton } from 'components/menu-button/MenuButton';

import s from './NavControls.scss';

interface IProps {
  children?: React.ReactNode;
}

export const NavControls = ({ children }: IProps) => {
  const { isHomepage } = useContext<any>(UIContext);
  const intl = useIntl();
  const { locale } = intl;

  return (
    <div className={s('navControls', { isHomepage })}>
      <div className={s.navControls__inner}>
        <div className={s.navControls__content}>
          <div className={s.navControls__linkWrap}>
            <div className={s.navControls__linkInner}>
            <Link to={`${getLang(locale)}/`} transition={!isHomepage} className={s.navControls__link}>
              {intl.formatMessage({
                id: 'sitename',
                defaultMessage: 'Miðstöð hönnunar og arkitektúrs',
              })}
            </Link>
            </div>
          </div>

          <div className={s.navControls__menuButton}>
            <MenuButton>Menu</MenuButton>
          </div>
        </div>

        
        {children}
      </div>
    </div>
  );
};
